export function emptySort() {
  return { column: null, direction: null };
}

export function cycleColumnSort(current, column) {
  const state = current || emptySort();
  if (state.column === column) {
    if (state.direction === 'asc') {
      return { column, direction: 'desc' };
    }
    if (state.direction === 'desc') {
      return emptySort();
    }
  }
  return { column, direction: 'asc' };
}

function formatAssigneeName(user) {
  if (!user) {
    return '';
  }
  const firstName = user.firstName || '';
  const lastName = user.lastName || '';
  return `${firstName} ${lastName}`.trim().toLowerCase();
}

/** Match TaskListSection display: first assignee, else assigned_user_names. */
function assigneeSortValue(task) {
  const first = task.assigned_users && task.assigned_users[0];
  if (first) {
    return formatAssigneeName(first);
  }
  return (task.assigned_user_names || '').trim().toLowerCase();
}

export function getTaskColumnSortValue(task, column) {
  switch (column) {
    case 'title':
      return (task.title || '').toLowerCase();
    case 'location':
      return (task.location_name || task.location || '').toLowerCase();
    case 'status':
      return (task.status || '').toLowerCase();
    case 'workGroup':
      return (task.work_group_name || '').toLowerCase();
    case 'scheduled': {
      const raw = task.scheduled_for || task.created_at;
      if (!raw) {
        return 0;
      }
      const time = new Date(raw).getTime();
      return Number.isNaN(time) ? 0 : time;
    }
    case 'assignedTo':
      return assigneeSortValue(task);
    default:
      return null;
  }
}

export function sortTasksByColumn(tasks, column, direction) {
  if (!column || !direction || !tasks || tasks.length === 0) {
    return tasks;
  }

  const decorated = tasks.map((task) => ({
    task,
    key: getTaskColumnSortValue(task, column)
  }));

  decorated.sort((a, b) => {
    const aValue = a.key;
    const bValue = b.key;

    if (typeof aValue === 'number' && typeof bValue === 'number') {
      return direction === 'asc' ? aValue - bValue : bValue - aValue;
    }

    const aStr = aValue == null ? '' : String(aValue);
    const bStr = bValue == null ? '' : String(bValue);
    return direction === 'asc'
      ? aStr.localeCompare(bStr)
      : bStr.localeCompare(aStr);
  });

  return decorated.map((entry) => entry.task);
}
